import { Header, quickPickLogo, quickRankLogo } from "@datagame/ui";
import { t } from "i18next";

import { QuickRankMode } from "../../../gql/graphql";
import { useGlobalConfiguration } from "../../../hooks/useGlobalConfiugration";
import { useQuickRankState } from "../../../hooks/quickrank/useQuickRankState";

import styles from "./Heading.module.scss";

export const Heading = () => {
  const { hideDatagameBranding } = useGlobalConfiguration();
  const [
    {
      configuration: { mode },
    },
  ] = useQuickRankState();

  const isQuickPick = mode === QuickRankMode.AllUp;

  if (hideDatagameBranding) {
    return null;
  }

  return (
    <div className={styles.rankifierTopBar}>
      <div className={styles.logoWrapper}>
        <img className={styles.logoImage} src={isQuickPick ? quickPickLogo : quickRankLogo} alt="rankifier logo" />
        <Header className={styles.logoText} variant="h6">
          {t("quickRank.headline", { gameName: isQuickPick ? "QuickPick" : "QuickRank" })}
        </Header>
      </div>
    </div>
  );
};
